(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', 'react-dropzone', 'react-emotion', '../../styles/colors', '../Buttons', '../../elements/typography'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('react-dropzone'), require('react-emotion'), require('../../styles/colors'), require('../Buttons'), require('../../elements/typography'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.classCallCheck, global.possibleConstructorReturn, global.inherits, global.react, global.reactDropzone, global.reactEmotion, global.colors, global.Buttons, global.typography);
    global.FileUpload = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _classCallCheck2, _possibleConstructorReturn2, _inherits2, _react, _reactDropzone, _reactEmotion, _colors, _Buttons, _typography) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _react2 = _interopRequireDefault(_react);

  var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n              width: ', ';\n              height: ', ';\n            '], ['\n              width: ', ';\n              height: ', ';\n            ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    background-color: ', ';\n    border-width: 2px;\n    border-color: ', ';\n    border-style: dashed;\n    border-radius: 6px;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  '], ['\n    background-color: ', ';\n    border-width: 2px;\n    border-color: ', ';\n    border-style: dashed;\n    border-radius: 6px;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: flex;\n    flex-flow: column wrap;\n    justify-content: center;\n    align-items: center;\n  '], ['\n    display: flex;\n    flex-flow: column wrap;\n    justify-content: center;\n    align-items: center;\n  ']),
      _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(['\n    flex: 1 1 auto;\n  '], ['\n    flex: 1 1 auto;\n  ']),
      _templateObject5 = (0, _taggedTemplateLiteralLoose3.default)(['\n    flex: 1 1 auto;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  '], ['\n    flex: 1 1 auto;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  ']);

  var FileUpload = function (_Component) {
    (0, _inherits3.default)(FileUpload, _Component);

    function FileUpload() {
      (0, _classCallCheck3.default)(this, FileUpload);
      return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
    }

    FileUpload.prototype.render = function render() {
      var _props = this.props,
          documentType = _props.documentType,
          componentWidth = _props.componentWidth,
          componentHeight = _props.componentHeight,
          maxFileSize = _props.maxFileSize,
          multipleFiles = _props.multipleFiles,
          testId = _props['data-testid'],
          onDragEnter = _props.onDragEnter,
          onDragOver = _props.onDragOver,
          onDragLeave = _props.onDragLeave,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          onDrop = _props.onDrop;

      var acceptedType = documentType === 'pdf' ? 'application/pdf' : '.csv';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactDropzone2.default,
          {
            'data-testid': testId,
            onDrop: onDrop,
            onDragEnter: onDragEnter,
            onDragOver: onDragOver,
            onDragLeave: onDragLeave,
            onDropAccepted: onDropAccepted,
            onDropRejected: onDropRejected,
            maxSize: maxFileSize,
            multiple: multipleFiles,
            accept: acceptedType,
            activeStyle: {
              borderColor: _colors2.default.leaf,
              backgroundColor: _colors2.default.mint
            },
            className: (0, _reactEmotion.cx)(classes.dropzone, (0, _reactEmotion.css)(_templateObject, componentWidth, componentHeight))
          },
          _react2.default.createElement(
            'div',
            { className: classes.divFragmentWrapper },
            {
              pdf: _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { className: classes.flexHelper },
                  _react2.default.createElement('img', {
                    width: '317px',
                    height: '197px',
                    src: 'img/upload-a-pdf-for-flyer.png',
                    alt: ''
                  })
                ),
                _react2.default.createElement(
                  _typography.Paragraph,
                  { bold: true, className: classes.textSpacingHelper },
                  'Drag and drop your PDF file here'
                ),
                _react2.default.createElement(
                  _typography.Paragraph,
                  null,
                  'or'
                ),
                _react2.default.createElement(
                  'div',
                  { className: classes.textSpacingHelper },
                  _react2.default.createElement(
                    _Buttons.ButtonSecondaryLarge,
                    { 'data-testid': 'click-' + testId },
                    'Upload Flyer'
                  )
                ),
                _react2.default.createElement(
                  _typography.Note,
                  null,
                  'Make sure your PDF file size is no more than 6MB'
                )
              ),
              csv: _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { className: classes.flexHelper },
                  '````',
                  _react2.default.createElement('img', {
                    width: '266px',
                    height: '197px',
                    src: 'img/csv-upload.png',
                    alt: ''
                  })
                ),
                _react2.default.createElement('div', { className: classes.flexHelper }),
                _react2.default.createElement(
                  'div',
                  { className: classes.textSpacingHelper },
                  _react2.default.createElement(
                    _Buttons.ButtonSecondaryLarge,
                    { 'data-testid': 'click-' + testId },
                    'Upload CSV File'
                  )
                )
              )
            }[documentType]
          )
        )
      );
    };

    return FileUpload;
  }(_react.Component);

  FileUpload.defaultProps = {
    documentType: null,
    componentWidth: '200px',
    componentHeight: '200px',
    maxFileSize: 6000000,
    multipleFiles: false
  };

  var classes = {
    dropzone: (0, _reactEmotion.css)(_templateObject2, _colors2.default.platinum, _colors2.default.silver),
    divFragmentWrapper: (0, _reactEmotion.css)(_templateObject3),
    flexHelper: (0, _reactEmotion.css)(_templateObject4),
    textSpacingHelper: (0, _reactEmotion.css)(_templateObject5)
  };
  exports.default = FileUpload;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUpload/FileUpload.js
// module id = 1231
// module chunks = 0